<template lang='pug'>
//- Payment-Failed
div(:class='$style[`cc-ecpay-container`]')
  div(:class='$style[`cc-ecpay-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 交
        span.font-normal-theme 易
        span.no-wrap 失敗

      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 交易流程發生問題，請確認付費資訊是否正確。

    div(:class='$style[`cc-banner-button`]')
      router-link(
        role='button'
        tabindex='0'
        aria-label='交易紀錄'
        :to='`/orders`'
        :class='$style[`cc-ecpay-redirect`]'
        title='交易紀錄'
      ) 交易紀錄
      router-link(
        role='button'
        tabindex='0'
        aria-label='繼續選購'
        :to='`/shop/subscribe`'
        :class='$style[`cc-ecpay-redirect`]'
        title='繼續選購'
      ) 繼續選購

    figure.graphic.graphic-pay_failed(:class='$style[`cc-ecpay-graphic`]')


</template>

<script>

export default {
  metaInfo() {
    return {
      title: '交易失敗',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/payment/failed',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/payment/failed',
      }],
    };
  },

  // methods: {
  //   axiosEcpaySaveRecord(authId) {
  //     getEcpaySuccessSaveRecord(`/?auth_id=${authId}`)
  //       .then((res) => {
  //         console.log('EcpaySuccessSaveRecord Success', authId, res);
  //       })
  //       .catch((err) => {
  //         console.log('EcpaySuccessSaveRecord Error', authId, err);
  //       })
  //   }
  // }

  // components: {
  // },

  // data () {
  //   return {
  //   }
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/info/ecpayStatus.scss';
</style>
